import {  Modal, Box, Typography } from '@material-ui/core';
import { AnimatedLoading } from '../portico/animated-loading/animated-loading'
import React from 'react';

interface CustomLoadingProps {
    message?: string;
    children?: React.ReactNode;
}

export const PortalLoading: React.FC<CustomLoadingProps> = ({ message, children }) => {
    const style = {
        position: 'absolute' as 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '536px',
        flexDirection: 'column',
        display: 'flex',
        height: '146px',
        padding: '16px',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        alignSelf: 'stretch',
        borderRadius: '4px',
        background: 'var(--neutrals-grey-00, #FFF)',
        boxShadow: '0px 24px 38px 0px rgba(0, 0, 0, 0.14), 0px 9px 46px 0px rgba(0, 0, 0, 0.12), 0px 11px 15px 0px rgba(0, 0, 0, 0.20)'
    }

    return (
        <Modal open={true} aria-labelledby="modal-title">
            <Box sx={{ ...style }}>
                <Typography style={{
                    alignSelf: 'stretch',
                    color:'var(--neutrals-grey-900, #212121)',
                    fontFamily: 'Roboto',
                    fontSize: '20px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '28px',
                }}>{message ?? children}</Typography>
                <AnimatedLoading />
            </Box>
        </Modal>
    )
}